export const currencyHandler = (price: number) => {
  if (!price) return ''
  return new Intl.NumberFormat('fa-ir').format(price)
}
